export default __webpack_public_path__ + "static/d-feature-5-db4db4096b0e51ff473eb9702ae56009.png";